import { IconDefinition } from "./types";

const rightArrow: IconDefinition = {
  iconName: "right-arrow",
  width: 16,
  height: 16,
  svgPathData: "M8.5 13l5-5-5-5M12 8H2",
  iconType: "stroke",
};

export { rightArrow };
